import { render, staticRenderFns } from "./Couraudio.vue?vue&type=template&id=76e8a368&scoped=true"
import script from "./Couraudio.vue?vue&type=script&lang=js"
export * from "./Couraudio.vue?vue&type=script&lang=js"
import style0 from "./Couraudio.vue?vue&type=style&index=0&id=76e8a368&prod&lang=scss&scoped=true"
import style1 from "./Couraudio.vue?vue&type=style&index=1&id=76e8a368&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76e8a368",
  null
  
)

export default component.exports